import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PatientexaminationParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientexaminationMst {
    id?: number;
      
    visitId:any;
    regId: string;
    examinationId: any; 
    tenantId: any;
    branchId: any;

    //IP Examination
    examinationNotes?:string;
    notes?:string;
    physicianId?:any;
    doctorId:any;
    admissionId:any;
    NameForQC?:string;
    docIdForQC ?:string;

    examinationDate:any;
    problemsince?:string;
    problemseverity?:string;
//Log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
    templateId?:number;
    templateName?:string
    parameters?: PatientexaminationParameter[];
    links?: any;
    attributeValue?:string
    attribute?:string
    controlType?:string;
    performingNurse?:string;
    performingDoctor?:string;
}
export abstract class PatientexaminationData { 

    abstract list(url: string): Observable<PatientexaminationMst[]>;
    abstract create(url: string, data: PatientexaminationMst): Observable<any>;
    abstract update(url: string, data: PatientexaminationMst): Observable<any>;
    abstract delete(url: string): Observable<any>;    
}
